import React, { useState } from 'react';
import { useProductSelector } from "../../stores/product/product.store";
import { ProductState } from "../../stores/product/product-state.interface";

interface ProductDescriptionProps {
    description: string;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ description }) => {
    const [expanded, setExpanded] = useState(false);
    const translate = useProductSelector((state: ProductState) => state.translate);

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <div className={ `overflow-hidden ${ expanded ? 'h-auto' : 'h-28' }` }>
                <div className="text-[14px]" dangerouslySetInnerHTML={ { __html: description } }></div>
            </div>
            <button className="text-[#585858] cursor-pointer mt-2 hover:bg-transparent hover:text-[#585858] focus:bg-transparent focus:text-[#585858]" onClick={ toggleExpand }>
                { expanded ? translate.collapse : translate.expand }
            </button>
        </>
    );
};

export default ProductDescription;